import React from 'react'
import { Link } from 'react-router-dom'
import MarketingSiteLayout from '../../marketing/MarketingSiteLayout'
import { PUBLIC_INQUIRY_PATH } from '../../marketing/marketingNav'
import LegalPolicyPublicSection from '../legal/LegalPolicyPublicSection'

const EFFECTIVE = '2026-07-20'

function RefundPolicyFallbackBody() {
  return (
    <>
      <p className="mt-4 text-sm text-slate-500">시행일 {EFFECTIVE} · 이용약관 제14조의 세부 기준입니다.</p>

      <div className="mt-10 space-y-10 text-sm leading-7 text-slate-700">
        <section>
          <h2 className="text-lg font-bold text-slate-900">1. 적용 범위</h2>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            <li>본 정책은 설계 EZ가 제공하는 유료 구독, 자동결제 구독, 앱 마켓 인앱구독, 유상 포인트, 쿠폰·프로모션, 조직 단위 계약 및 이에 부수하는 결제, 취소, 환불에 적용됩니다.</li>
            <li>App Store 또는 Google Play에서 결제한 개인 구독의 해지, 환불, 결제수단 변경, 갱신 관리는 해당 스토어의 정책과 구독 관리 절차가 우선합니다.</li>
            <li>조직 단위 별도 계약, 견적서, 세금계산서 기준 거래, 기업 계약 또는 서면 합의가 있는 경우 해당 계약 또는 별도 안내가 우선합니다.</li>
            <li>관련 법령에서 이용자에게 더 유리한 규정을 두는 경우 그 규정이 우선합니다.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900">2. 구독 및 해지</h2>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            <li>개인 구독은 월간 단위로 제공됩니다. 조직 단위 계약의 기간과 조건은 견적서 또는 계약서에 따릅니다.</li>
            <li>상품별 제공 범위, 월별 할당량, 포인트 지급, 무료 체험, 할인 또는 쿠폰 조건은 서비스 화면, 주문 화면, 견적서 또는 계약서에 따릅니다.</li>
            <li>무료체험은 별도 결제 또는 스토어 구독 동의 없이 유료로 자동 전환되지 않습니다.</li>
            <li>구독료 인상, 결제주기 변경 등 중요한 유료 조건 변경은 서비스 화면, 스토어 결제창 또는 별도 안내를 통해 사전 고지 및 동의 절차를 거칩니다.</li>
            <li>회사 직접 결제 구독은 서비스 내 설정, 고객문의 또는 support@sgez.co.kr을 통해 해지를 요청할 수 있습니다.</li>
            <li>App Store 또는 Google Play에서 결제한 개인 구독은 해당 스토어의 구독 관리 화면에서 직접 해지해야 하며, 앱 삭제 또는 서비스 탈퇴만으로 자동 해지되지 않습니다.</li>
            <li>구독을 해지하면 다음 결제주기부터 결제가 중단되며, 이미 결제된 이용기간은 별도 안내가 없는 한 만료일까지 유지됩니다.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900">3. 청약철회 및 환불 원칙</h2>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            <li>결제 완료 후 7일 이내이고, 서비스 내 주요 유료 기능을 한 번도 사용하지 않은 경우에만 전액 환불을 요청할 수 있습니다.</li>
            <li>유료 기능 사용에는 진료정보분석, 숨은보험금찾기, 설문/통합 리포트 AI, 진단시뮬레이션, 보험금청구, 사진 배경 제거와 같은 할당량형 기능뿐 아니라 고객등록, 계약·보험 정보 등록, 만기보험 등록, 명함생성, 리포트·자료 생성·저장·다운로드·공유 등 서비스 내 주요 기능 실행이 포함됩니다.</li>
            <li>단순 로그인, 화면 조회, 메뉴 진입, 설정 변경, 구독 페이지 또는 결제내역 조회처럼 서비스 결과물 생성이나 업무 데이터 처리가 없는 행위는 유료 기능 사용 여부 판단에서 제외될 수 있습니다.</li>
            <li>유료 기능을 1회 이상 사용하거나 디지털 서비스 제공이 개시된 경우 전액환불 및 부분환불은 원칙적으로 불가하며, 이미 결제된 이용기간은 만료일까지 제공됩니다.</li>
            <li>중복결제, 결제오류, 회사 귀책 장애, 관련 법령상 필요한 경우에는 회사가 확인 후 예외적으로 환불할 수 있습니다.</li>
            <li>조직 단위 계약 또는 좌석 기반 상품의 환불, 기간 조정, 상계, 크레딧 제공 여부는 별도 계약 조건과 실제 사용 내역을 고려하여 산정될 수 있습니다.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900">4. 포인트, 쿠폰 및 프로모션</h2>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            <li>구매 포인트는 관련 법령 및 회사 정책에 따라 미사용 잔액에 한해 환불 요청이 가능합니다. 이미 사용된 포인트는 환불 대상에서 제외됩니다.</li>
            <li>보너스 포인트, 프로모션 포인트, 쿠폰성 포인트는 현금 환불되지 않을 수 있으며, 구독 해지 또는 환불 시 회수·차감될 수 있습니다.</li>
            <li>쿠폰, 단체할인, 프로모션이 적용된 주문은 할인액 및 이미 사용된 혜택을 반영하여 환불 금액이 조정될 수 있습니다.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900">5. 신청 방법 및 처리</h2>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            <li>
              환불·취소 요청: 서비스 내 <strong className="text-slate-900">고객문의</strong> 또는 이메일{' '}
              <a className="font-semibold text-brand-navy underline" href="mailto:support@sgez.co.kr">
                support@sgez.co.kr
              </a>
            </li>
            <li>
              공개 문의:{' '}
              <Link className="font-semibold text-brand-navy underline" to={PUBLIC_INQUIRY_PATH}>
                문의하기
              </Link>
              (비회원 가능, 유료 결제·환불 식별을 위해 회원 정보를 함께 남겨 주세요.)
            </li>
            <li>회사는 이용 이력, 결제 기록, 포인트·할당량 사용 내역, 조직 계약 조건, 부정 이용 여부 등을 확인한 후 승인 여부와 환불 산정 결과를 안내합니다.</li>
            <li>환불이 승인된 경우, 결제 수단·PG·카드사 또는 스토어 정책에 따라 실제 환급까지 수일이 소요될 수 있습니다.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900">6. 제한 또는 불가 사유</h2>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            <li>약관 위반, 개인정보 오남용, 부정 이용, 시스템 침해, 광고성 정보 관련 법령 위반 등으로 이용이 제한된 경우</li>
            <li>고객등록, 계약·보험 정보 등록, 만기보험 등록, 명함생성, 리포트·자료 생성·저장·다운로드·공유 등 주요 유료 기능이 실행된 경우</li>
            <li>진료정보분석 결과, 숨은보험금 조회 지원 결과, 보험금청구 전송, 문자·알림톡 발송 등 원가가 발생하거나 결과물이 제공된 경우</li>
            <li>조직 계약, 별도 견적, 세금계산서 거래 또는 서면 합의에 따라 환불이 배제되거나 별도 규정이 있는 경우</li>
            <li>회원 또는 조직이 허위 정보, 타인 정보, 무권한 고객 데이터로 서비스를 이용한 경우</li>
          </ul>
        </section>

        <section className="rounded-2xl border border-amber-200 bg-amber-50/80 px-4 py-4 text-xs leading-relaxed text-amber-950">
          본 정책은 서비스 운영을 위한 안내이며, 상품·요금·환불 조건은 공지, 주문 화면, 스토어 정책, 별도 계약 및 관련 법령에 따라 조정될 수 있습니다.
        </section>

        <div className="flex flex-wrap gap-3 border-t border-slate-200 pt-8 text-sm">
          <Link to="/terms" className="font-semibold text-brand-navy underline-offset-2 hover:underline">
            이용약관
          </Link>
          <Link to="/privacy" className="font-semibold text-brand-navy underline-offset-2 hover:underline">
            개인정보처리방침
          </Link>
          <Link to="/checkout" className="font-semibold text-brand-navy underline-offset-2 hover:underline">
            결제 안내
          </Link>
        </div>
      </div>
    </>
  )
}

export default function RefundPolicyPage() {
  return (
    <MarketingSiteLayout>
      <div className="mx-auto max-w-3xl px-4 py-14 md:py-20">
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-brand-sky">정책</p>
        <h1 className="mt-4 text-3xl font-black tracking-tight text-slate-900 sm:text-4xl">청약철회·결제 취소 및 환불 정책</h1>

        <div className="mt-6">
          <LegalPolicyPublicSection
            docCode="REFUND_POLICY"
            fallback={
              <>
                <p className="text-xs text-slate-400">게시본이 없을 때 표시하는 내장 정책입니다.</p>
                <RefundPolicyFallbackBody />
              </>
            }
          />
        </div>
      </div>
    </MarketingSiteLayout>
  )
}